import React, { useState } from 'react';
import Layout from '../components/Layout';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import AutomationManager from '../components/AutomationManager';

const WhatsAppManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'analytics' | 'automation'>('analytics');

  return (
    <Layout>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Gerenciamento WhatsApp</h1>
          {/* Navigation Tabs */}
          <div className="flex space-x-1 mb-6">
            <button
              onClick={() => setActiveTab('analytics')}
              className={`px-6 py-3 rounded-md font-medium text-sm ${
                activeTab === 'analytics'
                  ? 'bg-blue-600 text-white'
                  : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
              title="Ver estatísticas e análises de mensagens WhatsApp"
            >
              📊 Analytics
            </button>
            <button
              onClick={() => setActiveTab('automation')}
              className={`px-6 py-3 rounded-md font-medium text-sm ${
                activeTab === 'automation'
                  ? 'bg-green-600 text-white'
                  : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
              title="Gerenciar regras de automação de mensagens"
            >
              🤖 Automação
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-6">
            {activeTab === 'analytics' && <AnalyticsDashboard />}
            {activeTab === 'automation' && <AutomationManager />}
          </div>
        </div>
    </Layout>
  );
};

export default WhatsAppManagement;